module.exports = __webpack_public_path__ + "static/media/homegym.e832e00a.png";